<template>
  <div>
    <el-button @click="add">增加</el-button>
    <el-button @click="test1">测试1</el-button>
    <el-button @click="test2">测试2</el-button>

    <div id="test">测试用div</div>
    <ul style="width: 300px; height: 300px; overflow-y: scroll; border: 1px solid black" id="sup">
      <transition-group>
      <li class="items" :id="getId(item.name)" :key="item.name" v-for="item in tableData" style="position: relative; width: 100%; background-color: white; margin: 10px; height: 30px; ">
        {{item.name}}
      </li>
      </transition-group>
    </ul>
  </div>
</template>
<script>
import jq from 'jquery'
export default {
  data () {
    return {
      index: 0,
      tableData:[
        {name:0},
      ]
    }
  },
  mounted () {

  },
  methods:{
    test1(){
      // jq("#test").hide(1000);
      jq("#test").animate({left:'250px'});
    },
    test2(){
      jq("#test").show(1000);
    },
    getId(id){
      return "item" + id;
    },
    add(){
      ++this.index;
      let obj = {};
      obj.name = this.index;
      this.tableData.unshift(obj);

    },

  }
}
</script>
<style>
  div{
    transition: 0.5s;
  }
</style>
